/**
 * Created by Mikhail Menshenin on 07.03.2025
 */

const CoinSlotMachinePaylineView = cc.Node.extend({
    ctor: function (slotMachine) {
        this._super();
        this.setAnchorPoint(0, 0);

        const fg = new cc.Sprite(bundles.slotmachine.frames.slot_machine_frame_png);
        this.setContentSize2(fg.getContentSize());
        fg.setLocalZOrder(10);
        fg.setPosition(this.width / 2, this.height / 2);
        this.addChild(fg);

        const bg = new cc.Sprite(bundles.slotmachine.frames.inner_part_png);
        bg.setPosition(this.width / 2, this.height / 2);
        this.addChild(bg);

        const reelViews = this.reelViews = slotMachine.reels.map((reel) => new CoinSlotMachineReelView(reel), this);
        const reelsLayout = new cleverapps.Layout(reelViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.CoinSlotMachinePaylineView.margin
        });
        reelsLayout.setPosition(this.width / 2, this.height / 2);
        this.addChild(reelsLayout);
    },

    getCurrentSymbolViews: function () {
        return this.reelViews.map((reelView) => reelView.getCurrentSymbolView());
    }
});

cleverapps.styles.CoinSlotMachinePaylineView = {
    margin: 75
};